import { render, staticRenderFns } from "./PdfFile.vue?vue&type=template&id=4628b6da&scoped=true&"
import script from "./PdfFile.vue?vue&type=script&lang=js&"
export * from "./PdfFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628b6da",
  null
  
)

export default component.exports